import { FC, useEffect, useRef } from "react";

import { Input, InputRef } from "antd";
import { debounce } from "lodash";

import { FieldType } from "../services/collectionFields";

const FieldColumnFilter: FC<{
  name: string;
  type: FieldType;
  value: string[];
  hideInput?: boolean;
  searchType?: "exact" | "contains";
  onFiltered: (filter: string, searchType?: "exact" | "contains") => void;
}> = ({ name, value, onFiltered, type, hideInput, searchType = "contains" }) => {
  const input = useRef<InputRef>(null);

  useEffect(() => {
    if (input.current?.input) {
      if (value && value.length === 1) {
        if (value[0].includes("***")) {
          input.current.input.value = value[0].replaceAll("*", "");
        } else if (value[0].includes("===")) {
          input.current.input.value = value[0].replaceAll("=", "");
        } else {
          input.current.input.value = "";
        }
      } else {
        input.current.input.value = "";
      }
    }
  }, [value]);

  const debounceOnChange = debounce(
    (event) => onFiltered(event.target.value, searchType),
    1000
  );

  if (type === "float" || type === "integer") return null;

  if (hideInput) return null;

  return (
    <Input
      ref={input}
      name={name}
      size="small"
      onChange={debounceOnChange}
      allowClear
      style={{ display: "flex", alignItems: "baseline" }}
    />
  );
};

export default FieldColumnFilter;
